import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-file-upload',
  templateUrl: './file-upload.component.html',
  styleUrls: ['./file-upload.component.css']
})
export class FileUploadComponent {
  @Output() imageSelected = new EventEmitter<FileList>(); // Use FileList para lidar com múltiplos arquivos
  @ViewChild('fileInput') fileInput: any;

  onFilesSelected(event: any) {
    const files: FileList = event.target.files;

    // Emita a lista de arquivos selecionados
    this.imageSelected.emit(files);
  }
}